import { render, staticRenderFns } from "./FieldRadio.vue?vue&type=template&id=60be6f72&"
import script from "./FieldRadio.vue?vue&type=script&lang=js&"
export * from "./FieldRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports